import { render, staticRenderFns } from "./QuickEditPanel.vue?vue&type=template&id=4b8c9810&scoped=true"
import script from "./QuickEditPanel.vue?vue&type=script&lang=js"
export * from "./QuickEditPanel.vue?vue&type=script&lang=js"
import style0 from "./QuickEditPanel.vue?vue&type=style&index=0&id=4b8c9810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c9810",
  null
  
)

export default component.exports